function indeterminate(state) {
	return state.appConfig.isLoading;
}

function companyLogo(state) {
	return state.user ? state.user.logo : '';
}

function userName(state) {
	return state.user ? state.user.username : '';
}

function token(state) {
	return state.token;
}

function snackbar(state) {
	return state.appConfig.snackbar;
}

const methods = {
	companyLogo,
	indeterminate,
	snackbar,
	token,
	userName,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/getters.js